import React from 'react';
import FivthFirst from './FivthFirst';
import OtherFivth from './OtherFivth';

const FivthContainer = ({ data, onClick }) => {
  return (
    <div className='mb-8 text-xxs sm:text-xs md:text-sm lg:text-lg xl:text-xl border border-black'>
      <FivthFirst />
      {/* <OtherFivth /> */}
      <div onClick={onClick} className='flex flex-row'>
        <div className='flex flex-col w-[12.5%] border border-black'>
          <div className='bg-blue-200 h-full flex justify-center items-center text-center'>중지현황</div>
        </div>
        <div className='w-full border border-black'>
          <div className='flex flex-row border-b-2 border-black'>
            <div className='w-[12.4%] h-[20px] sm:h-[30px] md:h-[40px] bg-blue-200 flex justify-center items-center text-center '>
              호기
            </div>
            <div className='w-[12.5%] h-[20px] sm:h-[30px] md:h-[40px] bg-blue-200 flex justify-center items-center text-center border-l-2 border-black'>
              지종
            </div>
            <div className='w-[12.5%] h-[20px] sm:h-[30px] md:h-[40px] bg-blue-200 flex justify-center items-center text-center border-l-2 border-black'>
              분
            </div>
            <div className='w-[12.55%] h-[20px] sm:h-[30px] md:h-[40px] bg-blue-200 flex justify-center items-center text-center border-l-2 border-black'>
              시간
            </div>
            <div className='w-[12.5%] h-[20px] sm:h-[30px] md:h-[40px] bg-blue-200 flex justify-center items-center text-center border-l-2 border-black'>
              구분
            </div>
            <div className='w-[37.54%] h-[20px] sm:h-[30px] md:h-[40px] bg-blue-200 flex justify-center items-center text-center border-l-2 border-black'>
              사유
            </div>
          </div>
          <div className='flex flex-row border-b-2 border-black'>
            <div className='w-[12.4%] h-[60px] sm:h-[90px] md:h-[120px] flex justify-center items-center text-center'>
              PM2
            </div>
            <div className='w-[12.5%] h-[60px] sm:h-[90px] md:h-[120px] flex text-center border-l-2 border-black'>
              <div className='flex flex-col flex-grow '>
                <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center border-b border-gray-400'></div>
                <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center border-b border-gray-400'></div>
                <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center '>
                  소계
                </div>
              </div>
            </div>
            <div className='w-[12.5%] h-[60px] sm:h-[90px] md:h-[120px] flex justify-center items-center text-center border-l-2 border-black'>
              <div className='flex flex-col flex-grow '>
                <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center border-b border-gray-400'></div>
                <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center border-b border-gray-400'></div>
                <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center '></div>
              </div>
            </div>
            <div className='w-[12.55%] h-[60px] sm:h-[90px] md:h-[120px] flex justify-center items-center text-center border-l-2 border-black'>
              <div className='flex flex-col flex-grow '>
                <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center border-b border-gray-400'></div>
                <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center border-b border-gray-400'></div>
                <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center '></div>
              </div>
            </div>
            <div className='w-[12.5%] h-[60px] sm:h-[90px] md:h-[120px] flex justify-center items-center text-center border-l-2 border-black'>
              <div className='flex flex-col flex-grow '>
                <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center border-b border-gray-400'></div>
                <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center border-b border-gray-400'></div>
                <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center '></div>
              </div>
            </div>
            <div className='w-[37.54%] h-[60px] sm:h-[90px] md:h-[120px] flex justify-center items-center text-center border-l-2 border-black'>
              <div className='flex flex-col flex-grow '>
                <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center border-b border-gray-400'></div>
                <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center border-b border-gray-400'></div>
                <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center '></div>
              </div>
            </div>
          </div>
          <div className='flex flex-row border-b-2 border-black'>
            <div className='w-[12.4%] h-[60px] sm:h-[90px] md:h-[120px] flex justify-center items-center text-center '>
              PM3
            </div>
            <div className='w-[12.5%] h-[60px] sm:h-[90px] md:h-[120px] flex text-center border-l-2 border-black'>
              <div className='flex flex-col flex-grow '>
                <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center border-b border-gray-400'></div>
                <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center border-b border-gray-400'></div>
                <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center '>
                  소계
                </div>
              </div>
            </div>
            <div className='w-[12.5%] h-[60px] sm:h-[90px] md:h-[120px] flex justify-center items-center text-center border-l-2 border-black'>
              <div className='flex flex-col flex-grow '>
                <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center border-b border-gray-400'></div>
                <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center border-b border-gray-400'></div>
                <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center '></div>
              </div>
            </div>
            <div className='w-[12.55%] h-[60px] sm:h-[90px] md:h-[120px] flex justify-center items-center text-center border-l-2 border-black'>
              <div className='flex flex-col flex-grow '>
                <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center border-b border-gray-400'></div>
                <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center border-b border-gray-400'></div>
                <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center '></div>
              </div>
            </div>
            <div className='w-[12.5%] h-[60px] sm:h-[90px] md:h-[120px] flex justify-center items-center text-center border-l-2 border-black'>
              <div className='flex flex-col flex-grow '>
                <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center border-b border-gray-400'></div>
                <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center border-b border-gray-400'></div>
                <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center '></div>
              </div>
            </div>
            <div className='w-[37.5%] h-[60px] sm:h-[90px] md:h-[120px] flex justify-center items-center text-center border-l-2 border-black'>
              <div className='flex flex-col flex-grow '>
                <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center border-b border-gray-400'></div>
                <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center border-b border-gray-400'></div>
                <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center '></div>
              </div>
            </div>
          </div>
          {/* 합계 부분 */}
          <div className='flex flex-row'>
            <div className='w-[24.9%] h-[20px] sm:h-[30px] md:h-[40px] flex text-center'>
              <div className='flex flex-col flex-grow '>
                <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center '>
                  합계
                </div>
              </div>
            </div>

            <div className='w-[12.5%] h-[20px] sm:h-[30px] md:h-[40px] flex text-center'>
              <div className='flex flex-col flex-grow border-l-2 border-black'>
                <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center '></div>
              </div>
            </div>

            <div className='w-[12.55%] h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center border-l-2 border-black'>
              <div className='flex flex-col flex-grow '>
                <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center '></div>
              </div>
            </div>
            <div className='w-[12.5%] h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center border-l-2 border-black'>
              <div className='flex flex-col flex-grow '>
                <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center '></div>
              </div>
            </div>
            <div className='w-[37.5%] h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center border-l-2 border-black'>
              <div className='flex flex-col flex-grow '>
                <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center '></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FivthContainer;
